/**
** JAVASCRIPTS
** Name: Finder
********************************************************************************/


/**
** Pre-imports
****************************************/

import * as L from 'leaflet';


/**
** Scripts
****************************************/

(function() {


  if(document.querySelector('.js-finder') && document.querySelectorAll('.js-finder-dealer').length > 0) {


    /**
    ** Variables
    ****************************************/

    const $finder   = document.querySelector('.js-finder');
    const $togglers = $finder.querySelectorAll('.js-finder-toggle');


    /**
    ** FUNCTION
    ** Set Map
    ****************************************/

    function setMap() {


      /**
      ** Variables
      ****************************************/

      const $scroller = $finder.querySelector('.js-finder-scroller');
      const $dealers  = $finder.querySelectorAll('.js-finder-dealer');
      const $map      = document.getElementById('map');
      const iconUrl   = $map.dataset.marker;
      const activeUrl = $map.dataset.active;

      const headerHeight = 80;
      const scrollOffset = 15;

      var markerIcon = L.icon({
        iconUrl:      iconUrl,
        shadowUrl:    false,
        iconSize:     [40, 40],
        shadowSize:   [0, 0],
        iconAnchor:   [20, 39],
        shadowAnchor: [0, 0],
        popupAnchor:  [0, -40]
      });

      var activeIcon = L.icon({
        iconUrl:      activeUrl,
        shadowUrl:    false,
        iconSize:     [40, 40],
        shadowSize:   [0, 0],
        iconAnchor:   [20, 39],
        shadowAnchor: [0, 0],
        popupAnchor:  [0, -40]
      });

      var popupOptions = {
        'maxWidth': '330',
        'width': '280'
      }

      var map     = L.map('map').setView([48.8588897, 2.320041], 13);
      var markers = [];


      /**
      ** Set tiles
      ***************************************/

      var OpenStreetMap_Mapnik = L.tileLayer('https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap France | &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      });

      OpenStreetMap_Mapnik.addTo(map);


      /**
      ** ACTION
      ** Create markers
      ***************************************/

      $dealers.forEach(function($dealer) {
        const lat  = $dealer.dataset.lat;
        const lng  = $dealer.dataset.lng;
        const slug = $dealer.dataset.slug;

        var $content = $dealer.cloneNode(true);

        $content.classList.remove('js-finder-dealer');
        $content.classList.add('c-dealer--popup');

        var marker = L.marker([lat, lng], {icon: markerIcon, slug: slug}).addTo(map);
        marker.bindPopup($content, popupOptions);

        markers.push(marker);

        $dealer.addEventListener('mouseover', function(e) {
          marker.setIcon(activeIcon);
        });

        $dealer.addEventListener('mouseout', function(e) {
          marker.setIcon(markerIcon);
        });
      });


      /**
      ** ACTION
      ** Map fit bounds
      ***************************************/

      if(markers.length > 0) {
        var markersGroup = new L.featureGroup(markers);
        map.fitBounds(markersGroup.getBounds());
      }


      /**
      ** ACTION
      ** On popup open / close
      ***************************************/

      map.on('popupopen', function(e) {
        const marker  = e.popup._source;
        const slug    = marker.options.slug;
        const $dealer = document.querySelector('.js-finder-dealer[data-slug="' + slug + '"]');
        const offset  = $dealer.offsetTop - headerHeight - scrollOffset;

        marker.setIcon(activeIcon);

        $dealer.classList.add('is-active');
        $scroller.scrollTo(0, offset);
      });

      map.on('popupclose', function(e) {
        var marker  = e.popup._source;
        var slug    = marker.options.slug;
        var $dealer = document.querySelector('.js-finder-dealer[data-slug="' + slug + '"]');

        marker.setIcon(markerIcon);
        $dealer.classList.remove('is-active');
      });


      $finder.classList.add('map-active');


    }


    /**
    ** Events
    ****************************************/

    $togglers.forEach(function($toggler) {
      $toggler.addEventListener('click', function(event) {
        event.preventDefault();
        $finder.classList.toggle('is-toggled');

        if(window.innerWidth < 960 && !$finder.classList.contains('map-active')) {
          setMap();
        }
      });
    });


    /**
    ** Init
    ****************************************/

    if(window.innerWidth >= 960) {
      setMap();
    }


  }

})();
